module.exports = __webpack_public_path__ + "img/16.d99ba50e.png";